import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function getContacts () {
  apiConsolelog('api: getContacts()')

  return request({
    url: '/contact-us/list',
    method: 'get'
  })
}
